// extracted by mini-css-extract-plugin
export default {"paginator":"paginator_paginator__noipc","page":"paginator_page__IspQ5","selectedPage":"paginator_selectedPage__U9hAm","controlBtn":"paginator_controlBtn__m3l9S"};